import {createSelector} from "reselect";
import {IStore} from "modules/types";

export const getPlayerPoolState = ({playerPoolReducer}: IStore) => playerPoolReducer;

export const getIsOpenPlayerPool = createSelector(getPlayerPoolState, ({isOpen}) => isOpen);

export const getPlayerPoolFilters = createSelector(getPlayerPoolState, ({filters}) => filters);

export const getPlayerPoolStatsFilter = createSelector(getPlayerPoolFilters, ({stats}) => stats);
